import { cn } from "@/lib/utils";

interface CardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const Card = ({ title, children, className }: CardProps) => {
  return (
    <section className="w-full rounded-tr-xl border-2 border-rw-white px-4 py-2 text-rw-dark-gray">
      <h3 className="text-xl font-semibold">{title}</h3>

      <hr className="my-2 border-t-2 border-rw-white" />

      <div className={cn("overflow-y-auto font-normal", className)}>
        {children}
      </div>
    </section>
  );
};
